<!--
입고라벨 샘플 출력
------------------------------------
-->
<template>
    <div style="display: none">

    </div>
</template>

<script>
    export default {
        props: {
            /**
             * 지역ID
             */
            regionId: Number,
        },
        data: function () {
            return {

            };
        },
        computed: {
        },
        methods: {

            /**
             * print
             * @param classification (int) 분류결과
             * @param urgent_type (int) 긴급여부
             */
            print(classification, urgent_type) {

                // ajax 옵션
                let opts = {
                    type: 'get',
                    url: '/regions/'+this.regionId+'/printer-setting/ship-in-label-sample',
                    data: {
                        'classification': classification,
                        'urgent_type': urgent_type,
                    },
                    success: (response, textStatus, jqXHR) => {
                        // 출력
                        $.app.print.label_by_zpls(response.zpls);
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>